<div class="modal-delete-social">
  <h2 class="social-dialog-title" mat-dialog-title>
    {{ data.modalTitle }}
    <div
      class="dismiss close-x-button"
      (click)="closeDetail()"
      (keydown.enter)="closeDetail()"
      tabindex="0"
      aria-label="Close Dialog"
    >
      <mat-icon class="close-button mat-icon" aria-hidden="true">close</mat-icon>
    </div>
  </h2>
  <mat-dialog-content>
    <p class="modal-text">{{ data.text }}</p>
    <div class="center-element">
      @if (data.secondaryButtonText) {
        <button (click)="cancelButtonClicked()" class="social-modal-buttons modal-secondary-button">
          {{ data.secondaryButtonText }}
        </button>
      }
      @if (data.primaryButtonText) {
        <button
          id="btnConfirmDelete"
          mat-raised-button
          (click)="confirmButtonClicked()"
          class="social-modal-buttons social-modal-button-primary"
        >
          {{ data.primaryButtonText }}
        </button>
      }
    </div>
  </mat-dialog-content>
</div>
